<ng-container *ngrxLet="showSpinner$ as showSpinner">

  @if (showSpinner) {
  <div class="content_loader">
    <div class="spinner-container">
      <mat-spinner [color]="'accent'" [diameter]="150"></mat-spinner>
      <div class="spinner-container-image-icon">
        <pbb-svg-icon [icon]="'konek-logo'"></pbb-svg-icon>
      </div>
    </div>
    <span> {{ 'COMMON.LOADING' | translate }}</span>
  </div>
  }

  <div class="full-content" [class.landing-bg]="isLandingPage">
    <router-outlet></router-outlet>
  </div>
  @if (!showSpinner && !hideFooter) {
  <footer role="contentinfo" [ngClass]="{'hideFooter': isCheckout, 'show-footer': isLandingPage }"
    [attr.aria-label]="'ARIA_LABEL.FOOTER' | translate">
    <pbb-footer id="footer"></pbb-footer>
  </footer>
  }
</ng-container>